import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal, MaskedLines, Overline } from "@/components/Motion";
import { usePage } from "@/settings";

const PANELS = [
  {
    key: "arch",
    to: "/work/architecture",
    testid: "work-architecture-panel",
    title: "Architecture",
    sub: "Buildings, interiors, research & visualisation",
    img: "https://images.unsplash.com/photo-1774516534049-b5b61d2275d8?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  {
    key: "art",
    to: "/work/art",
    testid: "work-art-panel",
    title: "Art",
    sub: "Paintings, portraits, wall art & commissions",
    img: "https://images.unsplash.com/photo-1744641405700-14e93917f6ed?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
];

export default function Work() {
  const pg = usePage("work");
  const panels = PANELS.map((p) => ({
    ...p,
    title: pg[`${p.key}_title`] || p.title,
    sub: pg[`${p.key}_sub`] || p.sub,
    img: pg[`${p.key}_image`] || p.img,
  }));
  return (
    <main data-testid="work-page" className="pt-32 pb-24 px-6 md:px-12 max-w-7xl mx-auto min-h-screen">
      <Overline>Work</Overline>
      <MaskedLines
        className="mt-6 mb-16"
        lineClassName="font-display text-5xl sm:text-6xl lg:text-8xl tracking-tight"
        lines={["Two practices,", "one studio."]}
      />
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {panels.map((p, i) => (
          <Reveal key={p.to} delay={i * 0.12}>
            <Link to={p.to} data-testid={p.testid} className="group relative block frame-clip spotlight aspect-[3/4] md:aspect-[4/5]">
              <img src={p.img} alt={p.title} className="w-full h-full object-cover" />
              <div className="absolute inset-0 bg-ink/35 group-hover:bg-ink/20 transition-colors duration-500" />
              <div className="absolute bottom-0 inset-x-0 p-8 text-paper">
                <div className="flex items-center justify-between">
                  <h2 className="font-display text-4xl md:text-6xl tracking-tight">{p.title}</h2>
                  <ArrowUpRight size={28} className="transition-transform duration-500 group-hover:translate-x-1 group-hover:-translate-y-1" />
                </div>
                <p className="mt-2 font-mono text-[10px] uppercase tracking-[0.25em] text-paper/70">{p.sub}</p>
              </div>
            </Link>
          </Reveal>
        ))}
      </div>
    </main>
  );
}
